module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background:#f3f3f3;\r\n}\r\n\r\n.button-add{\r\n    text-align: center;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/qualification-input/qualification-input-form/qualification-input-form.component.css
// module id = ./src/app/hrms/serviceregister/qualification-input/qualification-input-form/qualification-input-form.component.css
// module chunks = main